/**
 * @description Forces a hard reload of the entire app. Should only be used in special cases.
 */
export const reloadApp = () => {
  return window.location.reload();
};
